import { updateMetaTags, seoConfig, arabicSeoConfig } from './seo';

// Utility to set page titles and meta descriptions dynamically
export const setPageTitle = (title, description, pageName = null, language = 'en') => {
  const baseTitle = "Radix Technologies";
  const fullTitle = title ? `${title} | ${baseTitle}` : `${baseTitle} - IT Service Delivery & Cloud Solutions`;
  
  // Get SEO config for the page if pageName is provided
  const localizedConfig = language === 'ar' ? arabicSeoConfig : seoConfig;
  const pageConfig = pageName && localizedConfig[pageName] ? localizedConfig[pageName] : null;
  
  // Use SEO config if available, otherwise use provided values
  const finalTitle = pageConfig ? pageConfig.title : fullTitle;
  const finalDescription = pageConfig ? pageConfig.description : description;
  const keywords = pageConfig ? pageConfig.keywords : '';
  
  updateMetaTags(finalTitle, finalDescription, keywords);
};

export const pageTitles = {
  home: "IT Services & Cloud Solutions",
  about: "About Us - 19+ Years Excellence",
  services: "IT Services - DevOps, Cloud, AI",
  portfolio: "Portfolio - Success Stories",
  careers: "Careers - Join Our Team",
  plans: "Pricing Plans - Flexible Solutions",
  contact: "Contact Us - Get in Touch",
  blog: "Blog - IT, Cloud & AI Insights"
};

export const pageDescriptions = {
  home: "Expert IT services & cloud solutions. 19+ years experience, 164+ projects delivered. DevOps, AI development, mobile apps & managed services.",
  about: "Learn about Radix Technologies - 19+ years IT excellence, 164+ successful projects, 50+ happy clients. Meet our expert team and discover our values.",
  services: "Comprehensive IT services: DevOps automation, cloud migration, AI development, mobile apps, quality assurance & managed services.",
  portfolio: "Explore successful projects including Cloudify (acquired by Dell), EarlySense healthcare platform, and enterprise solutions for 50+ clients.",
  careers: "Join Radix Technologies! Remote-first culture with competitive salaries, learning opportunities. Open positions in development, AI/ML, DevOps.",
  plans: "Flexible engagement models for your project needs - startup MVP to dedicated teams. Project-based, cloud migration, or managed services.",
  contact: "Get in touch with Radix Technologies for your next project. Free consultation, 24-hour response time, and expert guidance for IT services.",
  blog: "Explore practical guidance on software delivery, cloud migration, DevOps, AI development, and digital product strategy from Radix Technologies."
};
